import { render, staticRenderFns } from "./PlusButton.vue?vue&type=template&id=bc9b4c8e&scoped=true"
import script from "./PlusButton.vue?vue&type=script&lang=js"
export * from "./PlusButton.vue?vue&type=script&lang=js"
import style0 from "./PlusButton.vue?vue&type=style&index=0&id=bc9b4c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9b4c8e",
  null
  
)

export default component.exports